import type { ReactNode } from "react";

import { cn } from "@/utils/cn";

// Figma: https://www.figma.com/design/HJIp5P6tyeFrUd7ODqeWdM/-PROD--Fertility-V?node-id=4887-28272

type IconRowProps = {
  /** A 16px icon from ui/icons. */
  icon: ReactNode;
  children: ReactNode;
  /** Layout only. */
  className?: string;
};

// Display component, no ref forwarded. See ui/README.md.
export const IconRow = ({ icon, children, className }: IconRowProps) => (
  <span
    className={cn(
      "flex items-center gap-ds-space-03 text-ds-text-primary ds-body-small-regular",
      className
    )}
  >
    <span className="flex shrink-0">{icon}</span>
    <span className="min-w-px flex-1">{children}</span>
  </span>
);
